import React, {useEffect, useRef, useState} from 'react';
import {BorderLeftESS, UploadContainer} from "./sign-up.styles";
import {TextInput, CheckBox, FileInput, Alert} from "../../core-ui";
import gsap from "gsap";
import {Link} from "react-router-dom";
import {Jumbotron} from "../../core-ui/jumbotron/jumbotron";
import {isValidSignUpForm, isValidVerificationCode} from "../../validations/schemas/sign-up";
import {fetchData, getMultiModeNumber} from "../../helpers/general-function";
import Notification from "../../helpers/notifications";

const formParams = {
    name: '',
    identification_code: '',
    mobile: '',
    email: '',
    type: 'student',
    license: {value: '', file: null},
};

const verificationForm = {
    user_id: '',
    verification_code: '',
}

const SignUp = () => {

    // import Num2persian from 'num2persian';
    // console.log(Num2persian(123));

    const firstStepRef = useRef(null);
    const secondStepRef = useRef(null);
    const thirdStepRef = useRef(null);
    const timeRef = useRef(null);

    const [signUpValues, setSignUpValues] = useState(formParams);
    const [verificationsValues, setVerificationsValues] = useState(verificationForm);
    const [isValidResendCode, setValidResendCode] = useState(false);
    const [timeInterval, setTimeInterval] = useState();

    useEffect(() => {
        return () => {
            clearInterval(timeInterval);
        }
    }, [timeInterval]);

    const changeHandler = ({target: {value, name, files}}) => {

        if (files) {
            setSignUpValues(prevStates => ({...prevStates, [name]: {value, file: files[0]}}));
        } else {
            setSignUpValues(prevStates => ({...prevStates, [name]: value}));
        }
    }

    const sendRegisterRequest = async () => {
        const isValidData = await isValidSignUpForm(signUpValues);

        if (!isValidData) {
            return false;
        }

        const data = await fetchData('register', 'post', {...signUpValues, license: signUpValues.license.file}, false, {
            existFile: true
        });

        if (data) {
            setVerificationsValues(prevState => ({...prevState, user_id: data.user.id}));
            timeRef.current.innerText = `${getMultiModeNumber(Math.floor(data.remaining_time / 60))}:${getMultiModeNumber(Math.floor(data.remaining_time % 60))}`;
            setTimeInterval(setInterval(countDownHandler, 1000));
            changeStep(firstStepRef, secondStepRef);
        }
    }

    const sendVerificationCode = async () => {
        const isValidData = await isValidVerificationCode(verificationsValues.verification_code);

        if (!isValidData) {
            return false;
        }

        const data = await fetchData('register/verify', 'post', verificationsValues);

        if (data) {
            clearInterval(timeInterval);
            changeStep(secondStepRef, thirdStepRef)
        }

    }

    const changeStep = (currentRef, targetRef, targetDisplay = 'd-flex') => {
        gsap.to(currentRef.current, .3, {
            opacity: 0,
            onComplete: () => {
                currentRef.current.classList.add('d-none');
                currentRef.current.style.opacity = '1';
                targetRef.current.classList.remove('d-none');
                targetRef.current.classList.add(targetDisplay);
                gsap.from(targetRef.current, .3, {
                    opacity: 0,
                })
            }
        })
    }

    const resendCode = async () => {
        setValidResendCode(false);
        timeRef.current.innerText = '01:10';
        setTimeInterval(setInterval(countDownHandler, 1000));
        Notification.danger('coming soon ...');
        // const data = await fetchData('register/verify', 'post', verificationsValues);
    }

    const countDownHandler = () => {
        try {
            let live_time = timeRef.current.innerText;

            if (!live_time || live_time === "") return false;
            let [m, s] = live_time.split(":");

            m = parseInt(m)
            s = parseInt(s)

            if (s !== 0) {
                s--;
            } else {
                if (m !== 0) {
                    m--;
                    s = 59;
                } else {
                    clearInterval(timeInterval);
                    setTimeInterval(null);
                    setValidResendCode(true);
                }
            }

            timeRef.current.innerText = `${getMultiModeNumber(m)}:${getMultiModeNumber(s)}`;

        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className='container-md mt-4'>
            <h3 className='success-color fw-normal d-lg-none text-end mt-5'>ثبت نام در فارماکار</h3>
            <Jumbotron>
                <h3 className='success-color fw-normal d-none d-lg-block'>ثبت نام در فارماکار</h3>
                <div ref={firstStepRef}>
                    <div className='rtl mt-5'>
                        <div className='row justify-content-center w-lg-100'>
                            <div className='col-12 col-lg-6 col-xl-5 col-xxl-4'>
                                <TextInput placeholder='نام و نام خانوادگی' value={signUpValues.name}
                                           onChange={changeHandler} wrapperClassNames='ms-lg-2' classNames='rtl'
                                           iconName='icon-user' name='name'/>
                            </div>
                            <div className='col-12 col-lg-6 col-xl-5 col-xxl-4'>
                                <TextInput placeholder='کد ملی' name='identification_code'
                                           iconName='icon-barcode'
                                           onChange={changeHandler} wrapperClassNames='me-lg-2 mt-4 mt-lg-0'
                                           value={signUpValues.identification_code}/>
                            </div>
                        </div>
                        <div className='row justify-content-center mt-4 mt-lg-5 w-lg-100'>
                            <div className='col-12 col-lg-6 col-xl-5 col-xxl-4'>
                                <TextInput placeholder='تلفن همراه' value={signUpValues.mobile}
                                           onChange={changeHandler} wrapperClassNames='ms-lg-2'
                                           iconName='icon-call' name='mobile'/>
                            </div>
                            <div className='col-12 col-lg-6 col-xl-5 col-xxl-4'>
                                <TextInput placeholder='ایمیل' name='email'
                                           iconName='icon-sms'
                                           caption='(اختیاری)'
                                           onChange={changeHandler} wrapperClassNames='me-lg-2 mt-4 mt-lg-0'
                                           value={signUpValues.email}/>
                            </div>
                        </div>

                        <div className='row justify-content-center w-100 mt-5'>
                            <BorderLeftESS className='col-6 col-lg-4 py-3 px-1 px-2'>
                                <CheckBox onChange={changeHandler}
                                          iconName='icon-user-edit'
                                          iconEnd
                                          value='student'
                                          name='type'
                                          id='student'
                                          classNames='me-auto ms-4'
                                          checked={signUpValues.type === 'student'}
                                          label='درحال تحصیل هستم'/>
                            </BorderLeftESS>
                            <div className='col-6 col-lg-4 py-3 px-1 px-2'>
                                <CheckBox onChange={changeHandler}
                                          iconName='icon-user-tick'
                                          value='employee'
                                          name='type'
                                          classNames='me-4'
                                          id='employee'
                                          checked={signUpValues.type === 'employee'}
                                          label='فارغ‌التحصیل هستم'/>
                            </div>
                        </div>
                        <UploadContainer className='text-center mt-5'>
                            <p>تصویر برگه 180 واحدی خود را آپلود کنید</p>
                            <FileInput label='انتخاب فایل'
                                       value={signUpValues.license.value}
                                       name='license'
                                       onChange={changeHandler}
                                       parentClassNames='mt-4'
                                       id='license'/>
                        </UploadContainer>

                        <div className='d-flex justify-content-end mt-c-5 mt-lg-3'>
                            <button className='c-btn c-btn-warning px-c-4 flex-grow-1 flex-lg-grow-0 py-c-2' onClick={sendRegisterRequest}>ادامه</button>
                        </div>
                    </div>
                </div>

                <div ref={secondStepRef} className='d-none flex-column flex-grow-1'>
                    <div className='rtl mt-5 flex-grow-1 d-flex flex-column justify-content-between'>

                        <div className='d-flex align-items-center justify-content-center flex-grow-1 mt-3'>
                            <div className='text-center w-100 w-lg-auto'>
                                <p className='dark-gray'>کد ارسال شده به شماره {signUpValues.mobile} را وارد کنید.</p>
                                <button className='btn-simple-text'
                                        onClick={() => changeStep(secondStepRef, firstStepRef, 'd-block')}>
                                    تغییر شماره تلفن
                                </button>
                                <div className='mt-6'>
                                    <TextInput placeholder='کد ارسال شده' value={verificationsValues.verification_code}
                                               onChange={(e) => setVerificationsValues(prevState => ({
                                                   ...prevState,
                                                   verification_code: e.target.value
                                               }))}
                                               wrapperClassNames='ms-2'
                                               classNames='rtl'
                                               iconName='icon-sms'/>
                                </div>
                                <div className='mt-4'>
                                    <button className={`btn-text dark-gray ${isValidResendCode ? '' : 'd-none'}`}
                                            onClick={isValidResendCode ? resendCode : () => {
                                            }}>
                                        <i className='ms-2 icon-location'/>ارسال مجدد
                                    </button>

                                    <p className={`mb-0 mt-5 mt-lg-0 gray-color ${isValidResendCode ? 'd-none' : ''}`}>ارسال مجدد در
                                        <span ref={timeRef} className='d-inline-block'
                                              style={{minWidth: '40px'}}>02:00</span>
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div className='d-flex justify-content-end mt-c-5 mt-lg-3'>
                            <button className='c-btn c-btn-warning px-c-4 flex-grow-1 flex-lg-grow-0 py-c-2'
                                    onClick={sendVerificationCode}>ادامه
                            </button>
                        </div>
                    </div>
                </div>

                <div ref={thirdStepRef} className='d-none flex-column flex-grow-1'>
                    <div className='rtl flex-grow-1 d-flex flex-column justify-content-between'>

                        <div className='d-flex align-items-center justify-content-center flex-grow-1 mt-3'>
                            <div className='text-center'>
                                <Alert/>
                                <h1 className='success-color mt-5'>ثبت نام شما با موفقیت انجام شد</h1>
                                <p className='gray-color mt-4'>پس از تایید هویت شما sms مربوطه را دریافت خواهید کرد</p>
                                <div className='mt-7'>
                                    <Link to='/' className='btn-simple-text dark-gray'>بازگشت به صفحه اصلی</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Jumbotron>
        </div>
    );
};

export default SignUp;
